'use client'

// P1.19: ssr:false must live in a Client Component — not a Server Component page.
// This wrapper is imported by the Server Component page; the dynamic() calls here
// defer mounting of these 6 sections to after TTI, eliminating the ~1400ms
// React hydration blocking task that was attributed to chalksports.ai/.
import dynamic from 'next/dynamic'

// FeatureGameDay (recap-only after walk-up music was pulled) was removed from
// the home 2026-05-29 — recap now lives once, in the BentoGrid recap strip.
const BentoGrid      = dynamic(() => import('./BentoGrid').then(m => ({ default: m.BentoGrid })), { ssr: false })
const FeatureClub    = dynamic(() => import('./FeatureClub').then(m => ({ default: m.FeatureClub })), { ssr: false })
const FeatureParents = dynamic(() => import('./FeatureParents').then(m => ({ default: m.FeatureParents })), { ssr: false })
const SocialProof    = dynamic(() => import('./SocialProof').then(m => ({ default: m.SocialProof })), { ssr: false })
const CTASection     = dynamic(() => import('./CTASection').then(m => ({ default: m.CTASection })), { ssr: false })

export function BelowFoldSections() {
  return (
    <>
      <BentoGrid />
      <FeatureClub />
      <FeatureParents />
      <SocialProof />
      <CTASection />
    </>
  )
}
